import { useCallback } from 'react'

import { useLogout } from '@scouts/auth'

import { useResetSession } from './use-reset-session'

export const useResetSessionAndLogout = () => {
    const { logout, isSuccess } = useLogout()

    const { resetSession } = useResetSession()

    const resetSessionAndLogout = useCallback(() => {
        resetSession()
        logout()
    }, [logout, resetSession])

    return { resetSessionAndLogout, isSuccess }
}
